__turbopack_context__.v({
  "body": "_1x9ILq_body",
  "dropdown": "_1x9ILq_dropdown",
});
